import React from 'react';
import { MessageCircle } from 'lucide-react';

const FloatingWhatsApp = () => {
  const whatsappLink = 'https://wa.me/393287686356?text=Ciao,%20ho%20bisogno%20di%20un%20intervento%20a%20Roma.%20Potete%20intervenire%20oggi?';

  return (
    <a
      href={whatsappLink}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-4 right-4 md:bottom-6 md:right-6 z-40 bg-whatsapp hover:bg-whatsapp-dark text-white rounded-full p-3 md:p-4 shadow-2xl transition-all duration-300 hover:scale-110 animate-pulse-subtle flex items-center justify-center group"
      aria-label="Contattaci su WhatsApp"
    >
      <MessageCircle className="h-7 w-7 md:h-8 md:w-8" />
      <span className="absolute right-full mr-3 bg-gray-900 text-white px-3 py-2 rounded-lg text-xs md:text-sm font-medium whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none hidden md:block">
        Scrivici su WhatsApp
      </span>
    </a>
  );
};

export default FloatingWhatsApp;
